export default "__VITE_ASSET__d98bc6ca__"